import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the TextImpressPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-text-impress',
  templateUrl: 'text-impress.html',
})
export class TextImpressPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad TextImpressPage');
  }

}



// WEBPACK FOOTER //
// /src/pages/textPages/text-impress/text-impress.ts